import { findReplayGroups } from '@picsart/web-replay-sdk/context';
import type { IReplay, IReplayGroupLayer } from '@picsart/web-replay-sdk';
import { getContext } from '@/context';

export interface FindSelectedCanvasGroupArgs {
  replay?: IReplay;
}

export type FindSelectedCanvasGroup = (
  args: FindSelectedCanvasGroupArgs
) => IReplayGroupLayer | null;

const findSelectedCanvasGroup: FindSelectedCanvasGroup = ({ replay }) => {
  const context = getContext();

  const replayGroups = findReplayGroups(replay ?? context.scene.replay);

  const canvasGroup = replayGroups.find(
    (group) => group.uuid === context.scene.selectedCanvasId
  );

  if (canvasGroup) return canvasGroup;

  return (
    replayGroups.filter((group) =>
      context.scene.hasLayerMediaType(group, 'CANVAS_GROUP')
    )[0] ?? null
  );
};

export default findSelectedCanvasGroup;
